import {useGetApi} from '@/uses/Api/useGetApi'

export const useValidateIntegratorHost = () => {
  const {
    get,
    status,
  } = useGetApi<unknown>()

  const validate = async (host: string): Promise<boolean> => {
    await get(`v2/integrators/hosts/${host}`)
    return status.value === 200
  }

  return {
    validate,
  }
}
